interface BuildLegCardIdClassAndFareHashParams {
  leg_card_id: string;
  class_xid: string;
  fare_id: string;
}

export const buildLegCardIdClassAndFareHash = ({
  leg_card_id,
  class_xid,
  fare_id
}: BuildLegCardIdClassAndFareHashParams) => {
  return `${leg_card_id}__${class_xid}__${fare_id}`;
};

export const parseLegCardIdClassAndFareHash = (hash: string) => {
  const [leg_card_id, class_xid, fare_id] = hash.split("__");
  return {
    leg_card_id,
    class_xid,
    fare_id
  };
};
